import type { SurfaceItem } from 'owa-calendar-surface-dategrid';
import { trace } from 'owa-trace';
import { findAllDayItemRow } from 'owa-calendar-surface-dategrid-common-dnd';

/**
 * Find the specified item (model) in a given week in month view
 * @param model The item model
 * @param weekIndex The week index
 * @param allWeeksVisibleItems An array of all visible rows of items for each week
 * @returns The row index for the item, if found in the week, -1 otherwise
 */
export default function findMonthItemRow(
    model: any,
    weekIndex: number,
    allWeeksVisibleItems: SurfaceItem[][][]
): number {
    if (weekIndex < 0 || weekIndex > allWeeksVisibleItems.length - 1) {
        trace.warn(`findMonthItemRow: bad week index provided ${weekIndex}`);
        return -1;
    }
    let weekItems = allWeeksVisibleItems[weekIndex];
    return findAllDayItemRow(model, weekItems);
}
